import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import { ProjectBody, ProjectDetails, ProjectListItem } from "types/api/project";

function useProjectApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllProject = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<ProjectListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<ProjectListItem>>({
            url: "/project",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneProject = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ProjectDetails> => {
        return get<PathParamsWithId, undefined, ProjectDetails>({
            url: "/project/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createProject = React.useCallback((body: ProjectBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, ProjectBody, ResponseWithId>({
            url: "/project",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateProject = React.useCallback((pathParams: PathParamsWithId, body: ProjectBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, ProjectBody, null>({
            url: "/project/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteProject = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/project/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllProject,
        getOneProject,
        createProject,
        updateProject,
        deleteProject
    };
}

export default useProjectApi;